import '../scss/index.scss';
import { alpine } from '@/helpers';

alpine();

if (process.env.NODE_ENV !== 'production') {
  console.log('MHCCNA > Currently in development mode');
}
